<template>
  <div class="collapse" style="background-color:#030f1e;">
    <div class="d-flex">
      <a href="javascript:void(0)" class="nav-link flex-fill justify-content-center">
        <i class="mr-1 fas fa-inbox"></i>
        <span class="small">
          {{ $t('inbox') }}
        </span>
      </a>
      <a href="javascript:void(0)" class="nav-link flex-fill justify-content-center">
        <i class="mr-1 fas fa-lock"></i>
        <span class="small">
          {{ $t('lock') }}
        </span>
      </a>
      <a href="javascript:void(0)" @click="$logout" class="nav-link flex-fill justify-content-center">
        <i class="mr-1 fas fa-sign-out-alt"></i>
        <span class="small">
          {{ $t('logout') }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
  module.exports = {
    name: 'ProfileDropdown'
  }
</script>

<i18n>
{
  "en": {
    "inbox": "Inbox",
    "lock": "Lock",
    "logout": "Log out"
  },
  "sl": {
    "inbox": "Prejeto",
    "lock": "Zakleni",
    "logout": "Odjava"
  }
}
</i18n>
